module.exports = __webpack_public_path__ + "img/password.ca0c2534.svg";